import { PcbNodeTypes } from "@buildwithflux/models";
import { Vector3 } from "three";
import { isTopLevelNodeOfType } from "../../../../nodes";
import { createLayoutShape } from "../../../../shapes";
import { getRotatedPosition, toMm } from "./support/utils";
function shapeToGrLine(shape, br) {
    const points = shape.getPoints(64).flatMap((point) => {
        const position = getRotatedPosition(new Vector3(point.x, -point.y, 0), br.rotationRelativeToDocument, true);
        return {
            x: toMm(position.x),
            y: toMm(position.y),
        };
    });
    const lineShapes = [];
    for (let i = 0; i < points.length; i++) {
        const start = points[i];
        const end = points[i + 1];
        if (start && end) {
            const position = {
                start: {
                    x: start.x + toMm(br.position.x),
                    y: start.y + toMm(-br.position.y),
                },
                end: {
                    x: end.x + toMm(br.position.x),
                    y: end.y + toMm(-br.position.y),
                },
            };
            const grLine = {
                ...position,
                layer: "Edge.Cuts",
                width: 0.05,
            };
            lineShapes.push(grLine);
        }
    }
    return lineShapes;
}
export const mapLayout = (layout, context, postprocess, pcbLayoutNodes) => {
    if (!isTopLevelNodeOfType(pcbLayoutNodes[layout.uid], PcbNodeTypes.layout)) {
        return null;
    }
    const br = layout.bakedRules;
    if (!br) {
        return null;
    }
    const shape = createLayoutShape(br);
    if (shape) {
        const lineShapes = shapeToGrLine(shape, br);
        postprocess((_, board) => {
            board.gr_line = board.gr_line ?? [];
            board.gr_line.push(...lineShapes);
        });
    }
    return null;
};
//# sourceMappingURL=mapLayout.js.map